
export default function CurrentIssues() {
  const issues = [
    {
      icon: 'ri-flask-line',
      title: 'Lead Content Defect Issue',
      description:
        'Serious defect issues are occurring where lead content exceeding standards is being detected in household water meters currently in distribution.',
      color: 'red',
    },
    {
      icon: 'ri-time-line',
      title: 'Long Usage Cycle Issue',
      description:
        'The reality is that reform is not happening as all meters including thermometers, heating meters, and gas meters intentionally require long-term use.',
      color: 'orange',
    },
    {
      icon: 'ri-government-line',
      title: 'Lack of Regulatory Standards',
      description:
        'While the US limits lead residue in water meters to 0.25% or less, Korea and some other countries have no clear restrictions on lead content residual impurities.',
      color: 'yellow',
    },
  ];

  const colorClasses = {
    red: {
      bg: 'bg-red-600',
      light: 'bg-red-50',
      text: 'text-red-600',
      border: 'border-red-200',
    },
    orange: {
      bg: 'bg-orange-600',
      light: 'bg-orange-50',
      text: 'text-orange-600',
      border: 'border-orange-200',
    },
    yellow: {
      bg: 'bg-yellow-600',
      light: 'bg-yellow-50',
      text: 'text-yellow-600',
      border: 'border-yellow-200',
    },
  };

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Current Issues</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            Current Social Issues
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-4 md:mb-6"></div>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium">
            Current problems in the water meter market and areas requiring improvement
          </p>
        </div>

        {/* Issue Cards */}
        <div className="grid md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16">
          {issues.map((issue, index) => {
            const classes = colorClasses[issue.color as keyof typeof colorClasses];
            if (!classes) {
              // Defensive fallback – skip rendering if color is invalid
              return null;
            }
            return (
              <div
                key={index}
                className={`bg-white border-2 ${classes.border} rounded-2xl p-5 md:p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
              >
                <div
                  className={`w-12 md:w-16 h-12 md:h-16 ${classes.bg} rounded-xl flex items-center justify-center mb-4 md:mb-6`}
                >
                  <i className={`${issue.icon} text-2xl md:text-3xl text-white`}></i>
                </div>
                <h3 className={`text-lg md:text-xl font-bold ${classes.text} mb-3 md:mb-4`}>
                  {issue.title}
                </h3>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                  {issue.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Our Solution */}
        <div className="bg-gradient-to-br from-teal-600 to-[#0a3d4f] rounded-2xl shadow-2xl p-5 md:p-8 lg:p-12 text-white">
          <div className="flex flex-col md:flex-row items-center gap-5 md:gap-8">
            <div className="w-14 md:w-20 h-14 md:h-20 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-3xl md:text-5xl text-teal-600"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-lg md:text-2xl lg:text-3xl font-bold mb-3 md:mb-4">
                We manufacture smart water meters using stainless steel and eco-friendly plastic materials at more competitive prices than Japan and Germany
              </h3>
              <p className="text-sm md:text-lg text-teal-100 leading-relaxed mb-4">
                We manufacture smart water meters using <strong className="text-white">stainless steel materials</strong> at more competitive prices than Japan for medical‑grade specifications.
              </p>
              <div className="flex flex-wrap gap-2 md:gap-4 justify-center md:justify-start">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 md:px-4 py-1.5 md:py-2">
                  <span className="font-semibold text-xs md:text-base whitespace-nowrap">
                    ✓ Zero Lead Content
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 md:px-4 py-1.5 md:py-2">
                  <span className="font-semibold text-xs md:text-base whitespace-nowrap">
                    ✓ Stainless Steel
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 md:px-4 py-1.5 md:py-2">
                  <span className="font-semibold text-xs md:text-base whitespace-nowrap">
                    ✓ Competitive Pricing
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 md:px-4 py-1.5 md:py-2">
                  <span className="font-semibold text-xs md:text-base whitespace-nowrap">
                    ✓ Medical‑grade Specs
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
